
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Talent Exploration</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm itoohavetalent section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>I Too Have A <span > Talent</span></h2>
        </div>

        <div class="col-md-12">
            <div class="widget_title inner-title">
                <h4>I TOO HAVE A TALENT <span class="small-sm">- A JOURNEY OF TALENT EXPLORATION</span></h4>
            </div>
            <h6>Raisoni Group always endeavors not only to nurture academic qualities of students but tries to bring out
                there Extra-Curricular talents</h6>
            <p>
                The very word brings to mind the images of star athletes, math club geniuses, gifted musicians and other
                prodigy like students. But is that all that there is to extra-curricular activities? Of course not, they
                are a lot more than just Singing, film making, sports and clubs comprised of genius students.
            </p>

            <div class="widget_title inner-title">
                <h4>I TOO HAVE A TALENT <span class="small-sm">- A MUSIC AND FILM MAKING COMPETITIONS</span></h4>
            </div>
            <p>A Music and film making Competitions is such a talent hunt program organized by Raisoni Group to give an
                exposure to things and activities that reside outside of students academic curriculum. College is a
                place that lays the foundation to students future and their career. It is a place where students not
                just get the academic knowledge but also where your overall personality development takes place. And
                it's the extra-curricular activities that are responsible for grooming your overall personality</p>

            <p>Employers today are looking for people who can bring to tables more than just academics. They are looking
                for candidates who are good in communicating and interacting with others. Technical skills can be taught
                but soft skills that extra-curricular activities in college help develop cannot be taught in a
                workplace.</p>

        </div>
        <div class="row text-center justify-content-center align-items-center">
            <div class="col-md-4">
                <a href="/photogallery#badminton" class="cmn-button"><span>
                    View Results</span>
                </a>
            </div>
        </div>
        <div class="border-line-sm"></div>
        <div class="row justify-content-center align-items-center row-cols-1 row-cols-md-2">
            <div class="col">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/faq.jpg" alt="GHRSCF">
            </div>
            <div class="col">
                <div class="accordion" id="accordion_1">
                    <div class="accordion-item">
                        <h4 class="accordion-header" id="t21">
                            <a class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#d21"
                                aria-expanded="true" aria-controls="d1">
                                Only Raisonians can perform?
                            </a>
                        </h4>
                        <div id="d21" class="accordion-collapse collapse show" aria-labelledby="t21"
                            data-bs-parent="#accordion_1">
                            <div class="accordion-body shadow-inset">
                                <p>Yes. The competition is for PAN RGI. Only students from Raisoni Group Institute can
                                    participate in the Competition. </p>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h4 class="accordion-header" id="t22">
                            <a class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#d22" aria-expanded="true" aria-controls="d1">
                                My partner is not from Raisoni College of engineering but i am so can we perform
                                together?
                                Is it allowed to take one participant from another college?
                            </a>
                        </h4>
                        <div id="d22" class="accordion-collapse collapse" aria-labelledby="t22"
                            data-bs-parent="#accordion_1">
                            <div class="accordion-body shadow-inset">
                                <p>No. The competition is for PAN RGI. Only students from Raisoni Group Institute can
                                    participate in the Competition. </p>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h4 class="accordion-header" id="t23">
                            <a class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#d23" aria-expanded="true" aria-controls="d1">
                                What should i upload a professional music video cover or just a mobile video singing
                                with guitar?
                            </a>
                        </h4>
                        <div id="d23" class="accordion-collapse collapse" aria-labelledby="t23"
                            data-bs-parent="#accordion_1">
                            <div class="accordion-body shadow-inset">
                                <p>Whatever is comfortable to you? The video will be judged on overall performance and
                                    the Likes you receive on video matters with the judge’s panel.</p>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
        <div class="row text-center justify-content-center align-items-center mt-5">
            <div class="col-md-4">
                <a href="https://urlzs.com/jyx5W" target="blank" class="cmn-button"><span>
                    Relevant Question</span>
                </a>
            </div>
        </div>
        <div class="border-line-sm"></div>
        <div class="row justify-content-center align-items-center row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="hovereffect hovereffect_div">
                    <img class="img-fluid"
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/musician.jpg" alt="GHRSCF">
                    <div class="overlay">
                        <h2>CALLING ALL MUSICIAN</h2>

                            <a href="musical-comp" target="blank" class="cmn-button"><span>
                                View More</span>
                            </a>

                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hovereffect hovereffect_div">
                    <img class="img-fluid"
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/shoot-sight.jpg" alt="GHRSCF">
                    <div class="overlay">
                        <h2>SHOOT AT SIGHT</h2>
                        <a href="shootsight-comp" target="blank" class="cmn-button"><span>
                            View More</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hovereffect hovereffect_div">
                    <img class="img-fluid"
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/step-up.jpg" alt="GHRSCF">
                        <div class="overlay">
                            <h2>STEP UP</h2>
                            <a href="stepup" target="blank" class="cmn-button"><span>
                                View More</span>
                            </a>
                        </div>
                </div>
            </div>

        </div>
        <div class="border-line-sm"></div>
        <div class="row  row-cols-1 row-cols-lg-2 justify-content-center align-items-center ">
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3>Go To Gallery <i class="fa fa-arrow-right blink" aria-hidden="true"></i></h3>
                            </div>

                            <a href="https://drive.google.com/drive/folders/1A6uZzJKCmSA-w7gGY5By-h5Qgp4AWujc?usp=share_link" target="blank" class="cmn-button"><span>
                                Read More</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
